import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { provideConfig } from '@spartacus/core'
import { CustomCheckoutOrderSummaryModule } from './custom-checkout-order-summary/custom-checkout-order-summary.module'
import { customB2BCheckoutConfig } from './custom-checkout-steps-config'
import { CustomCostCenterModule } from './custom-cost-center/custom-cost-center.module'
import { CustomDeliveryAddressModule } from './custom-delivery-address/custom-delivery-address.module'
import { CustomDeliveryModeModule } from './custom-delivery-mode/custom-delivery-mode.module'
import { CustomPaymentTypeModule } from './custom-payment-type/custom-payment-type.module'
import { CustomPlaceOrderModule } from './custom-place-order/custom-place-order.module'
import { CustomReviewSubmitModule } from './custom-review-submit/custom-review-submit.module'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CustomCheckoutOrderSummaryModule,
    CustomCostCenterModule,
    CustomDeliveryModeModule,
    CustomPaymentTypeModule,
    CustomDeliveryAddressModule,
    CustomReviewSubmitModule,
    CustomPlaceOrderModule
  ],
  providers: [provideConfig(customB2BCheckoutConfig)]
})
export class CustomCheckoutModule {}
